import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { className: "top_menu" }
const _hoisted_2 = { className: "v-navbar sp" }
const _hoisted_3 = { className: "wide background" }
const _hoisted_4 = { className: "v-navbar-item" }
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  style: {"width":"160px"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { className: "v-navbar-brand-bottom" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://twitter.com/joycon_jp",
    target: "blank",
    rel: "noopener noreferrer",
    className: "sns-link"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi sns-icon pi-twitter" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.instagram.com/joycon.jp/",
    target: "blank",
    rel: "noopener noreferrer",
    className: "sns-link"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi sns-icon pi-instagram" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.facebook.com/joycon.jp/",
    target: "blank",
    rel: "noopener noreferrer",
    className: "sns-link"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "pi sns-icon pi-facebook" })
  ])
], -1)
const _hoisted_10 = {
  key: 0,
  href: "/users/sign_out",
  rel: "nofollow",
  "data-method": "delete"
}
const _hoisted_11 = {
  key: 1,
  href: "/users/sign_in",
  rel: "nofollow"
}
const _hoisted_12 = { className: "v-navbar pc" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { className: "wide background" }, null, -1)
const _hoisted_14 = { className: "v-navbar" }
const _hoisted_15 = { className: "v-navbar-item" }
const _hoisted_16 = { className: "v-navbar-brand-right" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://twitter.com/joycon_jp",
  target: "blank",
  rel: "noopener noreferrer",
  className: "sns-link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi sns-icon pi-twitter" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.instagram.com/joycon.jp/",
  target: "blank",
  rel: "noopener noreferrer",
  className: "sns-link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi sns-icon pi-instagram" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.facebook.com/joycon.jp/",
  target: "blank",
  rel: "noopener noreferrer",
  className: "sns-link"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi sns-icon pi-facebook" })
], -1)
const _hoisted_20 = {
  key: 0,
  href: "/users/sign_out",
  rel: "nofollow",
  "data-method": "delete"
}
const _hoisted_21 = {
  key: 1,
  href: "/users/sign_in",
  rel: "nofollow"
}
const _hoisted_22 = {
  key: 2,
  style: {"width":"160px"}
}

import { ref } from "vue";
import { location_move } from "@/vue/router";


export default /*#__PURE__*/_defineComponent({
  props: {
  path: String,
  model: Object,
  user: Object,
  args: String,
},
  setup(__props) {

const props = __props



const user_top_menu = [
  {
    icon: "pi-vertical-line",
    label: "パーティースケジュール",
    command: (event) => {
      location_move("party");
    },
  },
  {
    icon: "pi-vertical-line",
    label: "サービス紹介",
    command: (event) => {
      location_move("service");
    },
  },
  {
    icon: "pi-vertical-line",
    label: "女医コンとは？",
    command: (event) => {
      location_move("what_joycon");
    },
  },
  {
    icon: "pi-vertical-line",
    label: "実績",
    command: (event) => {
      location_move("achievements");
    },
  },
  {
    icon: "pi-vertical-line",
    label: "メディア掲載",
    command: (event) => {
      location_move("media");
    },
  },
  {
    icon: "pi-vertical-line",
    label: "FAQ",
    command: (event) => {
      location_move("faq");
    },
  },
];

let user_menu;
if (props.user && "checked_in_party" in props.user) {
  user_menu = [
    {
      icon: "pi-vertical-line",
      label: "マイページ",
      command: (event) => {
        location_move("/mypage");
      },
    },
    {
      icon: "pi-vertical-line",
      label: "参加者一覧",
      command: (event) => {
        location_move(props.user.checked_in_party);
      },
    },
    {
      icon: "pi-vertical-line",
      label: "パーティースケジュール",
      command: (event) => {
        location_move("/parties/list");
      },
    },
    {
      icon: "pi-vertical-line",
      label:
        props.user.gender === "female"
          ? "お見合い（男性プロフィール検索）"
          : "お見合い",
      command: (event) => {
        location_move("/matchmaking/onboarding");
      },
    },
    {
      icon: "pi-vertical-line",
      label: "FAQ",
      command: (event) => {
        location_move("/faq");
      },
    },
  ];
} else {
  user_menu = [
    {
      icon: "pi-vertical-line",
      label: "マイページ",
      command: (event) => {
        location_move("/mypage");
      },
    },
    {
      icon: "pi-vertical-line",
      label: "パーティースケジュール",
      command: (event) => {
        location_move("/parties/list");
      },
    },
    {
      icon: "pi-vertical-line",
      label:
        props.user.gender === "female"
          ? "お見合い（男性プロフィール検索）"
          : "お見合い",
      command: (event) => {
        location_move("/matchmaking/onboarding");
      },
    },
    {
      icon: "pi-vertical-line",
      label: "FAQ",
      command: (event) => {
        location_move("/faq");
      },
    },
  ];
}
const admin_menu = [
  {
    label: "管理メニュー",
    icon: "far fa-calendar-alt",
    items: [
      {
        label: "開催中・開催予定の女医コン",
        icon: "far fa-calendar",
        command: (event) => {
          location_move("/parties");
        },
      },
      {
        label: "開催終了した女医コン",
        icon: "far fa-calendar-check",
        command: (event) => {
          location_move("/past_parties");
        },
      },
      {
        label: "キャンセル管理",
        icon: "fal fa-money-check-edit",
        command: (event) => {
          location_move("/cancels");
        },
      },
      {
        label: "指標管理",
        icon: "pi pi-fw pi-table",
        command: (event) => {
          location_move("/metrics");
        },
      },
    ],
  },
  {
    label: "ユーザー管理",
    icon: "fal fa-users-cog",
    items: [
      {
        label: "ユーザー管理",
        icon: "fal fa-users",
        command: (event) => {
          location_move("/users");
        },
      },
      {
        label: "男性、有料、お見合い",
        icon: "└",
        command: (event) => {
          location_move(
            "/users?user_filter%5Bgender%5D=male&user_filter%5Bmatchmaking%5D=entered&user_filter%5Bmembership_status%5D=only_membership"
          );
        },
      },
      {
        label: "女性、有料、お見合い",
        icon: "└",
        command: (event) => {
          location_move(
            "/users?user_filter%5Bgender%5D=female&user_filter%5Bmatchmaking%5D=entered&user_filter%5Bmembership_status%5D=only_membership"
          );
        },
      },
      {
        label: "メール管理",
        icon: "fal fa-mail-bulk",
        command: (event) => {
          location_move("/mails");
        },
      },
      {
        label: "お見合い管理",
        icon: "fal fa-rings-wedding",
        command: (event) => {
          location_move("/matchmaking/management");
        },
      },
      {
        label: "メール配信状況ログDL",
        icon: "fal fa-ballot-check",
        command: (event) => {
          location_move("/email_necessities.csv");
        },
      },
      {
        label: "退会情報",
        icon: "pi pi-fw pi-file",
        command: (event) => {
          location_move("/users/deleted_accounts");
        },
      },
    ],
  },
  {
    label: "有料会員・個別サポート",
    command: (event) => {
      location_move("/invited_candidates");
    },
  },
  {
    label: "フィードバックアンケート管理",
    command: (event) => {
      location_move("/feedback_surveys");
    },
  },
  {
    label: "基本データ管理",
    items: [
      {
        label: "プロフィール",
        icon: "",
        command: (event) => {
          location_move("/about_me_questions");
        },
      },
      {
        label: "出身大学",
        icon: "",
        command: (event) => {
          location_move("/schools");
        },
      },
      {
        label: "Ｑ＆Ａ",
        icon: "",
        command: (event) => {
          location_move("/frequently_asked_questions");
        },
      },
      {
        label: "開催エリア",
        icon: "",
        command: (event) => {
          location_move("/areas");
        },
      },
      {
        label: "テキスト",
        icon: "",
        command: (event) => {
          location_move("/block_texts");
        },
      },
      {
        label: "各種設定",
        icon: "",
        command: (event) => {
          location_move("/app_settings");
        },
      },
      {
        label: "職業・専門（実装中！）",
        icon: "",
        command: (event) => {
          location_move("/");
        },
      },
    ],
  },
];

// link_to users_path(user_filter: {
//                 gender: :male,
//                 membership_status: :only_membership,
//                 matchmaking: :entered
//               })
// link_to users_path(user_filter: {
//                 gender: :female,
//                 membership_status: :only_membership,
//                 matchmaking: :entered
//               })

let menu: any;
let mypage: string;
let login = false;
let widthClass = "section_width";

if (props.user && Object.keys(props.user).length) {
  login = true;
  if (props.user.is_admin) {
    menu = ref(admin_menu);
    mypage = "";
    widthClass = "section_width_admin";
  } else {
    menu = ref(user_menu);
    mypage = "/mypage";
  }
} else {
  menu = ref(user_top_menu);
  mypage = "/users/sign_in";
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(_unref(widthClass))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Menubar, {
          model: _unref(menu),
          class: "sp"
        }, {
          start: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("a", null, [
                  _createElementVNode("img", {
                    className: "logo",
                    src: "/design/logo.png",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(location_move)('/')))
                  })
                ]),
                (_unref(mypage))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _unref(mypage),
                      className: "login-icon"
                    }, _hoisted_7, 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (props.user.is_admin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          end: _withCtx(() => [
            _hoisted_9,
            (_unref(login))
              ? (_openBlock(), _createElementBlock("a", _hoisted_10, [
                  _createVNode(_component_Button, {
                    label: "ログアウト",
                    class: "login-link"
                  })
                ]))
              : (_openBlock(), _createElementBlock("a", _hoisted_11, [
                  _createVNode(_component_Button, {
                    label: "ログイン",
                    class: "login-link"
                  })
                ]))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Menubar, {
          model: _unref(menu),
          class: "pc"
        }, {
          start: _withCtx(() => [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("a", null, [
                  _createElementVNode("img", {
                    className: "logo",
                    src: "/design/logo.png",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(location_move)('/')))
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _hoisted_18,
                _hoisted_19,
                (_unref(login))
                  ? (_openBlock(), _createElementBlock("a", _hoisted_20, [
                      _createVNode(_component_Button, {
                        label: "ログアウト",
                        class: "login-link"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("a", _hoisted_21, [
                      _createVNode(_component_Button, {
                        label: "ログイン",
                        class: "login-link"
                      })
                    ])),
                (props.user.is_admin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ], 2)
  ]))
}
}

})